import React from 'react'
import CallOuts from "../../components/callouts"

export default ({currentItem}) => {
    // console.log(currentItem)
    return <article className="call-out-links">
        <h4>MORE WAYS TO MAXIMIZE YOUR FIELD</h4>
        <CallOuts currentItem={currentItem || null}></CallOuts>
    </article>
}